<tr>
	<ng-content select="[start]"></ng-content>
	<ng-content></ng-content>
	<ng-content select="[end]"></ng-content>
</tr>
